// extracted by mini-css-extract-plugin
export default {"wrapper":"eWI3g","content":"nWXKX"};